import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_COVER_SHEET_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_COVER_SHEET> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_COVER_SHEET,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_COVER_SHEET);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_COVER_SHEET> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_COVER_SHEET = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page1[0]",
	// "2":"topmostSubform[0].Page1[0].FINANCIAL_INSTITUTION[0]",
	totalNumberOfPage: 'topmostSubform[0].Page1[0].NBR_PAGES[0]',
	closingDate: 'topmostSubform[0].Page1[0].DATEDISBURSEMENTVERIFIED_ANG[0]',
	mortgageNumber: 'topmostSubform[0].Page1[0].ID_PRET_CLIENT[0]',
	propertyAddress: 'topmostSubform[0].Page1[0].ADRESSE_PROPRIETE[0]',
	clientName: 'topmostSubform[0].Page1[0].BWRLGLNM_OR_COMPANYNAME[0]',
	phoneNumber: 'topmostSubform[0].Page1[0].NOTAIRE_TEL[0]',
	firmName: 'topmostSubform[0].Page1[0].NOTAIRE_ETUDE[0]',
	solicitorName: 'topmostSubform[0].Page1[0].NOTAIRE_NOM_COMPLET[0]',
	createdDate: 'topmostSubform[0].Page1[0].DATE_CREATED_FAX[0]',
	// "12":"topmostSubform[0].Page1[0].BARCODE_FAX_RETURN_LENDER[0]",
	faxNumber: 'topmostSubform[0].Page1[0].NOTAIRE_FAX[0]',
};

export interface BMO_CONVENTIONAL_COVER_SHEET {
	createdDate: string;
	solicitorName: string;
	firmName: string;
	phoneNumber: string;
	faxNumber: string;
	// lenderName:string,
	clientName: string;
	propertyAddress: string;
	mortgageNumber: string;
	closingDate: string;
	totalNumberOfPage: string;
}
